module.exports = __webpack_public_path__ + "img/oufu_40x55x6_4b.prt.e8b1138d.jpg";